import React, { useState } from 'react'
import lpllogo from '../../assets/images/logo.png';
import suburbanlogo from '../../assets/images/suburban.webp';
import '../../assets/stylesheet/layout.scss';
import '../../assets/stylesheet/feedback.scss';
import 'font-awesome/css/font-awesome.min.css';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { ShowToastUtil } from '../../utilities/showToastUtil';
import GetUserData from '../../utilities/getUserDetails';

function SelectLanguage() {
    const navigate = useNavigate();
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [userInfo, setUserInfo] = useState(GetUserData());
    const [projectFilter, setProjectFilter] = useState('');
    const handleLangSelect = (e) => {
        setSelectedLanguage(e.target.value);
    };
    const handleNextbtn = () =>{
        if(selectedLanguage){
            if(projectFilter == ''){
                ShowToastUtil('Please select a project','warning');
                return;
            }
            const preferedLanguage = encodeURIComponent(selectedLanguage || '');
            navigate(`/referPage?lang=${preferedLanguage}&project=${projectFilter}`)
        }
        else{
            ShowToastUtil('Please selected a language', 'warning');
        }
    };
    const handleProjectFilter = (e) => {
        setProjectFilter(e.target.value);
    };
    const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
  return (
    <>
        <div className='container-fluid feedback-form'>
            <div className='row'>
            <div className="did-floating-label-content mb-0 ms-2 mt-4">
                          <select
                              className="did-floating-select h-50px" style={{width: '150px'}}
                              value={projectFilter}
                              onChange={handleProjectFilter}
                          >
                              <option value={""}>Select Project</option>
                              <option value={1}>Sample Collection</option>
                              <option value={4}>FTR</option>
                              <option value={5}>NFTR</option>
                          </select>
                          <label className="did-floating-label">
                              Project Filter
                          </label>
                      </div>
                  <div className='col-14 col-sm-14 col-md-9 col-lg-9 col-xl-9 '>
                      <div className='logo-section'>
                          {isSuburban ? (
                              <img alt="Suburban Diagnostics India Pvt Limited" className="f-logo" src={suburbanlogo} />
                          ) : (
                              <img alt="Dr Lal Path Labs" className="f-logo" src={lpllogo} />
                          )}

                      </div>
                  </div>
                <div className='col-14 col-sm-14 col-md-8 col-lg-8 col-xl-8'>
                    <div className='lang-section'>
                        <div className='text-center'>
                            <div className='Page-title mb-5 text-center'><h3>Select Language</h3></div>
                            <div className='text-center'>
                            {/* <Button variant="primary me-3 h-btn-filter"><i className='fa fa-filter'/></Button> */}
                                <Button className={selectedLanguage === 'eng'?'selectedButton':''} variant='primary' style={{minHeight:'36px',  borderRadius: '20px', width:'120px', marginRight: '10px'}} value={'eng'} onClick={handleLangSelect}>English</Button>
                                <Button className={selectedLanguage === 'hin'?'selectedButton':''} variant='primary' style={{minHeight:'36px', borderRadius: '20px',  width:'120px',}} value={'hin'} onClick={handleLangSelect}>हिन्दी</Button>
                            </div>
                        </div>
                       
                    </div>
                </div>
                  <div className='button-footer text-center'>
                      <div className='row justify-content-center'>
                          <div className='col-10 col-sm-6 col-md-4 col-lg-2 col-xl-2'>
                              <Button variant='primary w-100' style={{ minHeight: '32px', borderRadius: '20px' }} onClick={handleNextbtn}>Next</Button>
                          </div>
                      </div>
                  </div>
            </div>
        </div>
    </>
  )
}
export default SelectLanguage;
